module.exports = __webpack_public_path__ + "img/Prosegur.d7b3f80b.svg";